<template>
  <hm-content ref="hmcontent" class="page">
    <div class="mb20 top page_top">
      <div class="steps_content_day">
        <div class="list">
          <el-switch
            v-model="switchValue1"
            class="fl"
            style="display: block"
            active-color="#13ce66"
            @change="changeSwitch1"
            inactive-text="公海客户自动分配"
          >
          </el-switch>
          <span class="txt fl"
            >开启后，公海中无导购的客户自动按照规则分配导购</span
          >
        </div>
        <p class="change_col_btn fl" style="margin-top: 0" @click="changBtn('c1')" v-if="switchValue1">修改</p>
        <p class="switch_txt" v-if="switchValue1">
          <span v-if="radio1 == 1">导购联系后分配给联系的导购 </span>
          <span v-if="radio1 == 2"
            >导购联系后{{ input11 }}天内产生单次消费且大于{{
              input12
            }}元后分配给联系的导购</span
          >
          <span v-if="radio1 == 3"
            >导购联系后{{ input13 }}天内产生单次消费且大于{{
              input14
            }}元后分配给销售的导购</span
          >
          <span v-if="radio1 == 4"
            >根据下次购买高于{{ input15 }}元分配给销售导购</span
          >
        </p>
        <div class="list" style="margin-top: 30px">
          <el-switch
            v-model="switchValue2"
            class="fl"
            style="display: block"
            active-color="#13ce66"
            @change="changeSwitch2"
            inactive-text="客户自动进入公海"
          >
          </el-switch>
          <span class="txt fl">
            开启后，导购不维护自己的客户就会导致客户与导购脱离关系，进入公海客户中，并且在禾电掌上显示，扫码右边二维码查看效果
          </span>
        </div>
        <p class="change_col_btn fl" @click="changBtn('c2')" v-if="switchValue2">修改</p>
        <p class="switch_txt" v-if="switchValue2">
          <span v-for="(v, i) in loopList" :key="i" style="margin-left:0">
            <span v-for="(subItem, subI) in v.ruleList" :key="subI" style="margin-left:0">
              <span v-if="subItem.ischecked">{{subItem.memberType}}{{v.text1}}{{subItem.bindingDay}}{{v.text2}}{{subItem.ruleDay}}{{v.text3}}{{subItem.saleMoney}}{{v.text4}}</span>
            </span>
          </span>
          <!-- <span v-if="checked1"
            >客户绑定导购天数大于{{ checkInp1 }}天且按照最近{{
              checkInp2
            }}天，消费之和低于{{ checkInp3 }}元时进入公海
          </span>
          <span v-if="checked4"
            >客户绑定导购天数大于{{ checkInp31 }}天且按照最近{{
              checkInp32
            }}天,全部消费订单金额都低于{{ checkInp33 }}元时进入公海
          </span>
          <span v-if="checked2"
            >客户绑定导购天数大于{{ checkInp11 }}天且最近{{
              checkInp12
            }}天以上未进行联系时进入公海
          </span> -->
          <span v-if="checked3">导购离职后客户自动进入公海 </span>
        </p>
        <div class="list" style="margin-top: 30px">
          <el-switch
              v-model="switchValue3"
              class="fl"
              style="display: block"
              :disabled="!switchValue2 || !switchValue1"
              active-color="#13ce66"
              @change="changeSwitch3"
              inactive-text="企业微信自动分配"
              active-value="open"
              inactive-value="close"
          >
          </el-switch>
          <span class="txt fl">
            开启后，客户进入公海或自动分配导购时同时微信关系解绑、绑定企业微信关系
          </span>
        </div>
        <p class="switch_txt_wechat">
          仅企业微信功能开通有效，详情请查看<span class="blue pointer" @click="doWechat">企业微信</span>
        </p>
      </div>
      <img
        class="wechat_img"
        src="https://imgcdn.hemiao100.com/ThemePictures/wechat.png"
        alt=""
      />
    </div>

    <div class="tabForm">
      <div class="tabForm_top">
        <i class="tabForm_top_col fl"></i>
        <span class="tabForm_top_title fl">公海客户统计</span>
        <span class="fl tabForm_top_title" style="margin-left: 10px"
          >{{ totalNum }}人</span
        >
        <div class="seleteTime fr">
          <el-date-picker
            v-model="valueTime1"
            @change="changeTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <!-- <el-button type="primary" class="fr">查询</el-button> -->
        </div>
      </div>
      <div class="statistic">
        <div class="statistic_list fl" @click="tabBtn('1')">
          <div class="clo1"></div>
          <div class="user_num">自动进入公海数</div>
          <div class="detail">
            {{ unassignNums }}
            <!-- <span class="change_col">详细客户</span> -->
          </div>
        </div>
        <div class="statistic_list fl" @click="tabBtn('2')">
          <div class="clo2"></div>
          <div class="user_num">公海客户自动分配数</div>
          <div class="detail">
            {{ assignNums }}
          </div>
        </div>
      </div>
      <div class="trend">
        <div id="mainline" style="height: 400px"></div>
      </div>
    </div>

    <div class="tabForm tables">
      <div class="tabForm_top">
        <i class="tabForm_top_col fl"></i>
        <span class="tabForm_top_title fl">职员业绩统计</span>
        <div class="seleteTime fr">
          <el-date-picker
              v-model="query.employeeStatistics.employeeSelTime"
              @change="employeeChange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-cascader
              clearable
              style="marginRight:10px; margin-left: 10px"
              ref="cascader"
              v-model="query.employeeStatistics.orgCodes"
              :props="props"
              :show-all-levels="false"
              placeholder="请选择机构"
          ></el-cascader>
          <el-input
              class="inpts"
              placeholder="请输入导购手机号/姓名"
              v-model="query.employeeStatistics.employeeInput"
              clearable
          >
          </el-input>
          <el-button type="primary" size="small" style="margin-left: 10px"  @click="searchBtn('3')"
          >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
            :data="dataLists.employeeStatisticsList"
            style="width: 100%"
            ref="table"
            @sort-change="employeeSort"
            stripe
            border
            size="small"
        >
          <el-table-column
              header-align="center"
              align="center"
              label="销售员"
              prop="employeeRealname"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="所属机构"
              prop="orgName"
          >
          </el-table-column>
          <el-table-column
              sortable="custom"
              header-align="center"
              align="center"
              label="客户流失数"
              prop="unassignNum"
          ></el-table-column>
          <el-table-column
              sortable="custom"
              header-align="center"
              align="center"
              label="客户分配数"
              prop="assignNum"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination" style="margin-top: 20px">
          <el-pagination
              background
              :total="dataLists.employeeStatisticsTotal"
              @current-change="employeeChangePage"
              @size-change="employeeChangePageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="query.employeeStatistics.pageNo"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="tabForm tables">
      <div class="tabForm_top">
        <i class="tabForm_top_col fl"></i>
        <span class="tabForm_top_title fl">机构业绩统计</span>
        <div class="seleteTime fr">
          <el-date-picker
              v-model="query.orgCodeStatistics.orgCodeSelTime"
              @change="orgCodeChange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-cascader
              clearable
              style="marginRight:10px; margin-left: 10px"
              ref="cascader"
              v-model="query.orgCodeStatistics.orgCodes"
              :props="props"
              :show-all-levels="false"
              placeholder="请选择机构"
          ></el-cascader>
          <el-button type="primary" size="small" style="margin-left: 10px"  @click="searchBtn('4')"
          >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
            :data="dataLists.orgCodeStatisticsList"
            style="width: 100%"
            ref="table"
            stripe
            border
            @sort-change="orgSort"
            size="small"
        >
          <el-table-column
              header-align="center"
              align="center"
              label="所属机构"
              prop="orgName"
          ></el-table-column>
          <el-table-column
              sortable="custom"
              header-align="center"
              align="center"
              label="客户流失数"
              prop="unassignNum"
          ></el-table-column>
          <el-table-column
              sortable="custom"
              header-align="center"
              align="center"
              label="客户分配数"
              prop="assignNum"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination" style="margin-top: 20px">
          <el-pagination
              background
              :total="dataLists.orgCodeStatisticsTotal"
              @current-change="orgChangePage"
              @size-change="orgChangePageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="query.orgCodeStatistics.pageNo"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="tabForm tables">
      <div class="tabForm_top">
        <i class="tabForm_top_col fl"></i>
        <span class="tabForm_top_title fl">客户出公海分配导购记录</span>
        <div class="seleteTime fr">
          <el-date-picker
            v-model="selTime1"
            @change="change1"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-input
            class="inpts"
            placeholder="请输入会员手机号/姓名"
            v-model="input1"
            clearable
          >
          </el-input>
          <el-input
            class="inpts"
            placeholder="请输入导购手机号/姓名"
            v-model="input2"
            clearable
          >
          </el-input>
          <el-button type="primary" size="small" style="margin-left: 10px"  @click="searchBtn('1')"
            >查询</el-button
          >
          <el-button
              type="success"
              size="small"
              @click="output('assign')"
              :loading="isOutputing"
          >导出</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          :data="dataList1"
          style="width: 100%"
          ref="table"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            label="会员手机号"
            prop="memberMobile"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="客户姓名"
            prop="memberName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="分配导购时间"
            prop="assignGuiderTime"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="分配导购"
            prop="employeeRealname"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="所属机构"
              prop="orgName"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="关联订单号"
              prop="assignReceiptSn"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="原因"
            prop="operReason"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination" style="margin-top: 20px">
          <el-pagination
            background
            :total="total1"
            @current-change="paging1"
            @size-change="handleSizeChange1"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage1"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="tabForm tables">
      <div class="tabForm_top">
        <i class="tabForm_top_col fl"></i>
        <span class="tabForm_top_title fl">客户进公海记录</span>
        <div class="seleteTime fr">
          <el-date-picker
            v-model="selTime2"
            @change="change2"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-input
            class="inpts"
            placeholder="请输入会员手机号/姓名"
            v-model="input3"
            clearable
          >
          </el-input>
          <el-input
            class="inpts"
            placeholder="请输入导购手机号/姓名"
            v-model="input4"
            clearable
          >
          </el-input>
          <el-button type="primary" size="small" style="margin-left: 10px" @click="searchBtn('2')"
            >查询</el-button
          >
          <el-button
              type="success"
              size="small"
              @click="output('unassign')"
              :loading="isOutputing"
          >导出</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          :data="dataList2"
          style="width: 100%"
          ref="table"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            label="会员手机号"
            prop="memberMobile"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="客户姓名"
            prop="memberName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="注册时间"
            prop="createTime"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="进入公海时间"
            prop="unassignGuiderTime"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="触发导购"
            prop="employeeRealname"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="所属机构"
              prop="orgName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="原因"
            prop="operReason"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination" style="margin-top: 20px">
          <el-pagination
            background
            :total="total2"
            @current-change="paging2"
            @size-change="handleSizeChange2"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage2"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 公海客户自行分配导购 -->
    <el-dialog
      :close-on-click-modal="false"
      title="公海客户自行分配导购"
      width="75%"
      :visible.sync="dialogVisible1"
      :before-close="dialogVisibleClose1"
    >
      <div class="btn-wrapper">
        <div class="steps_content steps_content1"></div>
        <div class="steps_content_day">
          <div class="steps_content_day">
            <el-radio
              class="steps_content_day_lt"
              style="margin-bottom: 10px; width: 100%"
              v-model="radio1"
              label="1"
              >导购联系后分配给联系的导购
            </el-radio>
            <el-radio
              class="steps_content_day_lt"
              style="margin-bottom: 15px; width: 100%"
              v-model="radio1"
              label="2"
            >
              <span class="radio_span">导购联系后</span>
              <el-input
                style="margin: 0 10px"
                v-model="input11"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天内产生单次消费且大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="input12"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元后分配给联系的导购</span>
            </el-radio>
            <el-radio
              class="steps_content_day_lt"
              style="margin-bottom: 15px; width: 100%"
              v-model="radio1"
              label="3"
            >
              <span class="radio_span">导购联系后</span>
              <el-input
                style="margin: 0 10px"
                v-model="input13"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天内产生单次消费且大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="input14"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元后分配给销售的导购</span>
            </el-radio>
            <el-radio
              class="steps_content_day_lt"
              style="margin-bottom: 15px; width: 100%"
              v-model="radio1"
              label="4"
            >
              <span class="radio_span">根据下次购买高于</span>
              <el-input
                style="margin: 0 10px"
                v-model="input15"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元分配给销售导购</span>
            </el-radio>

            <div class="steps_content_day" style="padding-left: 20px">
              <span class="steps_content_day_lt">导购有多个时</span>
              <el-select
                v-model="valueSel"
                clearable
                placeholder="请选择"
                class="content_sel"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="btn_box">
          <el-button
            type="primary"
            size="small"
            @click="popBtn('pop1', 'yes')"
            class="btn"
            >确定</el-button
          >
          <el-button
            type="info"
            size="small"
            @click="popBtn('pop1', 'no')"
            class="btn"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="客户自动进入公海"
      width="75%"
      :visible.sync="dialogVisible2"
      :before-close="dialogVisibleClose2"
    >
      <div class="btn-wrapper">
        <div class="steps_content steps_content1"></div>
        <div class="steps_content_day">
          <!-- <div class="steps_content_day">
            <el-checkbox
              v-model="checked1"
              class="steps_content_day_lt"
              style="width: 100%; margin-bottom: 20px"
              label="a"
            >
              <span class="radio_span">客户绑定导购天数大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp1"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天且按照最近</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp2"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天，消费之和低于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp3"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元时进入公海</span>
            </el-checkbox>

            <el-checkbox
              v-model="checked4"
              class="steps_content_day_lt"
              style="width: 100%; margin-bottom: 20px"
              label="d"
            >
              <span class="radio_span">客户绑定导购天数大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp31"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天且按照最近</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp32"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天,全部消费订单金额都低于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp33"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元时进入公海</span>
            </el-checkbox>

            <el-checkbox
              v-model="checked2"
              class="steps_content_day_lt"
              style="width: 100%; margin-bottom: 20px"
              label="b"
            >
              <span class="radio_span">客户绑定导购天数大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp11"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天且最近</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp12"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天以上未进行联系时进入公海</span>
            </el-checkbox>

            <el-checkbox
              v-model="checked3"
              class="steps_content_day_lt"
              style="width: 100%; margin-bottom: 20px"
              label="c"
            >
              <span class="radio_span">导购离职后客户自动进入公海</span>
            </el-checkbox>
          </div> -->
<!--修改开始-->
          <div class="loopList">
            <div class="loopList_div" v-for="(v, i) in loopList" :key="i">
              <div class="title">
                <span class="radio_span">{{i+1}}.请选择会员群组:</span>
                <el-select
                  style="width: 200px;"
                  size="small"
                  placeholder="请选择会员群组"
                  v-model="v.memberSelected"
                  @change="memberSelect(v)"
                  class="mr10"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in v.memberClass"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>

              <div class="loopList_item flex flex-between" v-for="(subItem, subI) in v.ruleList" :key="subI">                
                <el-checkbox
                v-model="subItem.ischecked"
                @change="changeischeck(subItem)"
                class="steps_content_day_lt flex-1"
                style="width: 100%; margin-bottom: 20px;"
                label="a"
              >
                <span class="radio_span">{{subItem.memberType}}{{v.text1}}</span>
                <el-input
                  style="margin: 0 10px"
                  v-model="subItem.bindingDay"
                  placeholder="请填写天数"
                  clearable
                ></el-input>
                <span class="radio_span">{{v.text2}}</span>
                <el-input
                  style="margin: 0 10px"
                  v-model="subItem.ruleDay"
                  placeholder="请填写天数"
                  clearable
                ></el-input>
                <span class="radio_span">{{v.text3}}</span>
                <el-input
                  style="margin: 0 10px"
                  v-if="v.text4!==''"
                  v-model="subItem.saleMoney"
                  placeholder="请填写金额"
                  clearable
                ></el-input>
                <span class="radio_span">{{v.text4}}</span>
                </el-checkbox>
                <div class="flex symbol" v-if="v.memberSelected!==''">
                  <div class="add-wrapper flex flex-center" v-if="v.ruleList.length<2">
                    <span
                      class="hmicon icon-hao pointer"
                      @click="addChildren(v)"
                    ></span>
                  </div>
                  <div class="minus-wrapper" style="margin-left:20rpx;" v-if="v.ruleList.length>1 && subI!==0">
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="removeChild(v,i)"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <el-checkbox
                v-model="checked3"
                class="steps_content_day_lt"
                style="width: 100%; margin-bottom: 20px"
                label="c"
              >
                <span class="radio_span">导购离职后客户自动进入公海</span>
            </el-checkbox>
  <!--修改结束-->          

          </div>

        </div>
        <div class="btn_box">
          <el-button
            type="primary"
            size="small"
            @click="popBtn('pop2', 'yes')"
            class="btn"
            >确定</el-button
          >
          <el-button
            type="info"
            size="small"
            @click="popBtn('pop2', 'no')"
            class="btn"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import echarts from "echarts";
// import VeLine from "v-charts/lib/line.common";
// import HmStep from "@/components/HmStep";
// import { mapGetters } from "vuex";
// import { setCookie, getCookie, removeCookie } from "../../utils/utils";

export default {
  components: {
    // HmStep,
    // VeLine
  },
  data() {
    return {
      isOutputing: false,
      totalNum: 0,
      inputNum: 0,
      inputsaleMoney: 0,
      activeIndex: "1",
      sumCnts: 0,
      newContactCnts: 0,
      negativeFeedbackCnts: 0,
      assignNums: 0,
      unassignNums: 0,
      storeCode: null,
      dialogVisible1: false,
      dialogVisible2: false,
      inputDay: null,
      options: [
        {
          value: "选项1",
          label: "分配给销售多的导购"
        },
        {
          value: "选项2",
          label: "不分配，以后导购联系或销售分配"
        }
      ],
      value: "",
      value1: false,
      value2: false,
      checked1: false,
      checked2: false,
      checked3: true,
      checked4: false,
      switchValue1: false,
      switchValue2: false,
      checkInp1: "",
      checkInp2: "",
      checkInp3: "",
      checkInp11: "",
      checkInp12: "",
      checkInp31: "",
      checkInp32: "",
      checkInp33: "",
      valueSel: "分配给销售多的导购",
      unassignGuiderRuleList: [],
      unassignGuiderRuleList1: [],
      unassignGuiderRuleList2: [],
      unassignGuiderRuleList3: [],
      unassignGuiderRuleList4: [],
      assignGuiderRule1: {
        allotGuiderType: "",
        ruleTypeNumber: "",
        contactDay: "",
        saleMoney: "",
        manyGuiderRule: ""
      },
      RuleSwitch: [],
      list: [],
      currentPage1: 1,
      pageSize1: 10,
      total1: 0,
      currentPage2: 1,
      pageSize2: 10,
      total2: 0,
      chartData: {
        columns: ["dateValue", "公海客户数", "自动进入公海数"],
        rows: []
      },
      dataList1: [],
      dataList2: [],
      memberSelected:"",
      memberClass:[
          {
            name: "全部会员",
            value: "",
          },
          {
            name: "普通会员",
            value: "normal",
          },
          {
            name: "plus会员",
            value: "plus",
          }
      ],
      loopList:[
        {
          id:1,
          text1:"客户绑定导购天数大于",
          text2:"天且按照最近",
          text3:"天，消费之和低于",
          text4:"元时进入公海",
          memberSelected:"",
          memberClass:[
              {
                name: "全部会员",
                value: "",
              },
              {
                name: "普通会员",
                value: "normal",
              },
              {
                name: "plus会员",
                value: "plus",
              }
          ],
          ruleList: [
            {
              memberType:"全部会员",
              ischecked:false,
              bindingDay:"",
              ruleDay:"",
              saleMoney:"",
              ruleTypeNumber:"notConsume",
            }
          ],
        },
        {
          id:2,
          text1:"客户绑定导购天数大于",
          text2:"天且按照最近",
          text3:"天，全部消费订单金额都低于",
          text4:"元时进入公海",
          memberSelected:"",
          memberClass:[
          {
                name: "全部会员",
                value: "",
              },
              {
                name: "普通会员",
                value: "normal",
              },
              {
                name: "plus会员",
                value: "plus",
              }
          ],
        ruleList: [
          {
              memberType:"全部会员",
              ischecked:false,
              bindingDay:"",
              ruleDay:"",
              saleMoney:"",
              ruleTypeNumber:"notContact",
          }
        ],
        },
        {
          id:3,
          text1:"客户绑定导购天数大于",
          text2:"天且最近",
          text3:"天以上未进行联系时进入公海",
          text4:"",
          memberSelected:"",
          memberClass:[
          {
            name: "全部会员",
            value: "",
          },
          {
            name: "普通会员",
            value: "normal",
          },
          {
            name: "plus会员",
            value: "plus",
          }
        ],
        ruleList: [
          {
              memberType:"全部会员",
              ischecked:false,
              bindingDay:"",
              ruleDay:"",
              saleMoney:"",
              ruleTypeNumber:"notConsumeEvery",
          }
        ],
        }
      ],
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      radio1: "",
      radio2: "",
      radio3: "",
      radio4: "",
      radio90: "",
      input11: "",
      input12: "",
      input13: "",
      input14: "",
      input15: "",
      valueTime1: [],
      selTime1: [],
      selTime2: [],
      queryStartTime: "",
      queryEndTime: "",
      optionLineData: [],
      optionLine: {
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value",
          axisLabel: {},
          minInterval: 1
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#B839F2"
                }
              }
            },
            areaStyle: {
              color: "#B839F2"
            }
          }
        ],
      },
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
                .dispatch("queryOrganizationTree", {
                  pageNo: 1,
                  pageSize: 999,
                  loginType: "store"
                })
                .then(res => {
                  res.result.records.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  this.query.orgCodeStatistics.orgCodes = [res.result.records[0].value];
                  this.queryOrgStatisticsList();
                  resolve(res.result.records);
                });
          } else {
            this.$store
                .dispatch("queryOrganizationListByParent", {
                  parentId: data.treeStruct,
                  loginType: "store"
                })
                .then(res => {
                  if (res.code === "0" && res.result) {
                    res.result.forEach(v => {
                      v.leaf = Boolean(!v.isParent);
                      v.value = v.orgCode;
                      v.label = v.departName;
                    });
                    resolve(res.result);
                  } else {
                    resolve([]);
                  }
                });
          }
        }
      },
      query: {
        employeeStatistics: {
          pageNo: 1,
          pageSize: 10,
          orgCodes: "",
          employeeSelTime: [],
          orgCode: "",
          employeeInput: "",
          orderBy: "",
          orderType: ""
        },
        orgCodeStatistics: {
          pageNo: 1,
          pageSize: 10,
          orgCodes: "",
          orgCodeSelTime: [],
          orgCode: "",
          orderBy: "",
          orderType: ""
        }
      },
      dataLists: {
        employeeStatisticsList: [],
        employeeStatisticsTotal: 0,
        orgCodeStatisticsList: [],
        orgCodeStatisticsTotal: 0
      },
      switchValue3: "close"
    };
  },
  watch: {
    radio1: {
      handler(val) {}
    },
    valueSel: {
      handler(val) {}
    },
    optionLineData: {
      handler(val) {}
    }
  },
  created() {
    // this.storeCode = getLoginUser().storeCode;
    this.changePage();

    let curDate = new Date();
    let curDate0 = new Date(curDate.getTime());
    let queryStartTime0 = this.formatDateTime(curDate0);
    let preDate7 = new Date(curDate.getTime() - 7 * 24 * 60 * 60 * 1000); //前7天
    let queryStartTime7 = this.formatDateTime(preDate7);

    this.queryStartTime = queryStartTime7;
    this.queryEndTime = queryStartTime0;
    this.valueTime1 = [this.queryStartTime, this.queryEndTime];
    this.selTime1 = [this.queryStartTime, this.queryEndTime];
    this.selTime2 = [this.queryStartTime, this.queryEndTime];
    this.query.employeeStatistics.employeeSelTime = [this.queryStartTime, this.queryEndTime];
    this.query.orgCodeStatistics.orgCodeSelTime = [this.queryStartTime, this.queryEndTime];
  },
  mounted() {},
  methods: {
    //跳往企业微信
    doWechat() {
      this.$router.push({
        path: "/wechat/index"
      });
    },
    //机构客户流失数排序
    orgSort(sort) {
      this.query.orgCodeStatistics.orderBy = sort.prop;
      if (null == sort.order) {
        this.query.orgCodeStatistics.orderType = null;
      } else if ("descending" == sort.order) {
        this.query.orgCodeStatistics.orderType = "desc";
      } else if ("ascending" == sort.order) {
        this.query.orgCodeStatistics.orderType = "asc";
      }
      this.queryOrgStatisticsList();
    },
    //职员客户流失数排序
    employeeSort(sort) {
      this.query.employeeStatistics.orderBy = sort.prop;
      if (null == sort.order) {
        this.query.employeeStatistics.orderType = null;
      } else if ("descending" == sort.order) {
        this.query.employeeStatistics.orderType = "desc";
      } else if ("ascending" == sort.order) {
        this.query.employeeStatistics.orderType = "asc";
      }
      this.queryEmployeeStatisticsList();
    },
    //导出
    async output(type) {
      let searchParam = {};
      if ("assign" == type) {
        searchParam = {
          queryStartTime: this.selTime1[0],
          queryEndTime: this.selTime1[1],
          centerKeyword: this.input1,
          guiderKeyword: this.input2,
          assignType: type
        };
      } else {
        searchParam = {
          queryStartTime: this.selTime2[0],
          queryEndTime: this.selTime2[1],
          centerKeyword: this.input3,
          guiderKeyword: this.input4,
          assignType: type
        };
      }
      console.log("searchParam  =======", searchParam);
      const searchCondition = JSON.parse(JSON.stringify(searchParam));
      await this.$store.dispatch("gonghaiAssignRecordExport", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
    // 页面初始化判断是否进入首页
    async changePage() {
      const { result } = await this.$store.dispatch("gonghaiStoreInit");
      console.log("result: ", result);
      if (result == "no") {
        this.$router.push({
          name: "GHindex"
        });
        return;
      } else {
        this.getgonghaiRule1();
        this.getgonghaiRule2();
        this.gonghaiEcharts();
        this.gonghaiData1();
        this.gonghaiData2();
        this.getgonghaiSeasMeber();
        this.getgonghaiSeasMeberNum();
        this.queryEmployeeStatisticsList();
        this.queryQywxFriendSwitch();
      }
    },
    async queryQywxFriendSwitch() {
      const { result } = await this.$store.dispatch("queryQywxFriendSwitch");
      this.switchValue3 = result == "yes" ? "open" : "close";
    },
    changeSwitch1(e) {
      if (e == true) {
        this.dialogVisible1 = true;
        this.switchValue1 = false;
      } else {
        let params = {
          assignGuiderRuleSwitch: "no"
        };
        this.assignRuleConfig(params);
        this.dialogVisible1 = false;
      }
    },
    changeSwitch2(e) {
      if (e == true) {
        this.dialogVisible2 = true;
        this.switchValue2 = false;
      } else {
        let params = {
          unassignGuiderRuleSwitch: "no"
        };
        this.unassignRuleConfig(params);
        this.dialogVisible2 = false;
      }
    },
    async changeSwitch3(e) {
      console.log(e);
      let params = {
        val: e
      }
      await this.$store.dispatch("editQywxFriendSwitch", params);
      this.$message({
        type: "success",
        message: "操作成功"
      });
    },
    tabBtn(type) {
      if (type == "1") {
        this.activeIndex = "1";
      }
      if (type == "2") {
        this.activeIndex = "2";
      }
      this.gonghaiEcharts();
    },
    formatDateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d;
    },
    // 修改
    changBtn(val) {
      console.log("val-----", val);
      if (val == "c1") {
        this.dialogVisible1 = true;
      }
      // if (!this.switchValue1 && val == "c1") {
      //   this.dialogVisible1 = false;
      // }
      if (val == "c2") {
        this.dialogVisible2 = true;
      }
      // if (!this.switchValue2 && val == "c2") {
      //   this.dialogVisible2 = false;
      // }
    },
    // 弹框的确定取消按钮
    popBtn(pop, type) {
      if (type == "yes" && pop == "pop1") {
        if (!this.radio1 && !this.valueSel) {
          this.$message({
            message: "请设置！",
            type: "warning"
          });
          return false;
        }
        if (this.radio1 == 2 && (!this.input11 || !this.input12)) {
          this.$message({
            message: "请输入天数和金额！",
            type: "warning"
          });
          return false;
        }
        if (this.radio1 == 3 && (!this.input13 || !this.input14)) {
          this.$message({
            message: "请输入天数和金额！",
            type: "warning"
          });
          return false;
        }
        if (this.radio1 == 4 && !this.input15) {
          this.$message({
            message: "请输入金额！",
            type: "warning"
          });
          return false;
        }
        if (this.radio1 == 1) {
          this.assignGuiderRule1 = {
            allotGuiderType: "contact",
            ruleTypeNumber: "contact",
            manyGuiderRule: this.valueSel
          };
        }
        if (this.radio1 == 2) {
          this.assignGuiderRule1 = {
            allotGuiderType: "contact",
            ruleTypeNumber: "consumeContact",
            contactDay: this.input11,
            saleMoney: this.input12,
            manyGuiderRule: this.valueSel
          };
        }
        if (this.radio1 == 3) {
          this.assignGuiderRule1 = {
            allotGuiderType: "sale",
            ruleTypeNumber: "consumeSale",
            contactDay: this.input13,
            saleMoney: this.input14,
            manyGuiderRule: this.valueSel
          };
        }
        if (this.radio1 == 4) {
          this.assignGuiderRule1 = {
            allotGuiderType: "sale",
            ruleTypeNumber: "sale",
            saleMoney: this.input15,
            manyGuiderRule: this.valueSel
          };
        }
        let params = {
          assignGuiderRule: this.assignGuiderRule1,
          assignGuiderRuleSwitch: "yes"
          // assignGuiderRuleSwitch: this.switchValue1 ? "yes" : "no",
        };
        console.log("switchValue1111", this.switchValue1);
        this.assignRuleConfig(params);
      }
      if (type == "no" && pop == "pop1") {
        this.dialogVisible1 = false;
      }
      if (type == "yes" && pop == "pop2") {
        this.dialogVisible1 = false;
        
        // if (
        //   this.checked1 &&
        //   (!this.checkInp1 || !this.checkInp2 || !this.checkInp3)
        // ) {
        //   this.$message({
        //     message: "请输入天数和金额！",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (
        //   this.checked4 &&
        //   (!this.checkInp31 || !this.checkInp32 || !this.checkInp33)
        // ) {
        //   this.$message({
        //     message: "请输入天数和金额！",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.checked2 && (!this.checkInp11 || !this.checkInp12)) {
        //   this.$message({
        //     message: "请输入天数和金额！",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (!this.checked1 && !this.checked2 && !this.checked3) {
        //   this.$message({
        //     message: "请选择",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.checked1) {
        //   this.unassignGuiderRuleList1 = [
        //     {
        //       bindingDay: this.checkInp1,
        //       ruleDay: this.checkInp2,
        //       saleMoney: this.checkInp3,
        //       ruleTypeNumber: "notConsume"
        //     }
        //   ];
        // } else {
        //   this.unassignGuiderRuleList1 = [];
        // }
        // if (this.checked4) {
        //   this.unassignGuiderRuleList4 = [
        //     {
        //       bindingDay: this.checkInp31,
        //       ruleDay: this.checkInp32,
        //       saleMoney: this.checkInp33,
        //       ruleTypeNumber: "notConsumeEvery"
        //     }
        //   ];
        // } else {
        //   this.unassignGuiderRuleList4 = [];
        // }
        // if (this.checked2) {
        //   this.unassignGuiderRuleList2 = [
        //     {
        //       bindingDay: this.checkInp11,
        //       ruleDay: this.checkInp12,
        //       ruleTypeNumber: "notContact"
        //     }
        //   ];
        // } else {
        //   this.unassignGuiderRuleList2 = [];
        // }
        // if (this.checked3) {
        //   this.unassignGuiderRuleList3 = [
        //     {
        //       ruleTypeNumber: "leave"
        //     }
        //   ];
        // } else {
        //   this.unassignGuiderRuleList3 = [];
        // }
        // this.RuleSwitch = this.unassignGuiderRuleList1
        //   .concat(this.unassignGuiderRuleList2)
        //   .concat(this.unassignGuiderRuleList3)
        //   .concat(this.unassignGuiderRuleList4);
        // let params = {
        //   unassignGuiderRuleList: this.RuleSwitch,
        //   unassignGuiderRuleSwitch: "yes"
        //   // unassignGuiderRuleSwitch: this.switchValue2 ? "yes" : "no",
        // };
        // this.unassignRuleConfig(params);
        console.log("点击1");
        let return_val=true;
        this.loopList.forEach(o =>{
            if(!o.text4){
              o.ruleList.forEach(v => {
                if(v.ischecked && !v.bindingDay && !v.ruleDay && !v.saleMoney)
                  {
                    return_val=false;
                  }
              })
            }else{
              o.ruleList.forEach(v => {
                if(v.ischecked && !v.bindingDay && !v.ruleDay)
                  {
                    return_val=false;
                  }
              })
            }
        })  
        if(return_val===false){
          this.$message({
            message: "请输入天数和金额！",
            type: "warning"
          });
          return false;
        }
        console.log("提交");
        this.loopList[0].ruleList.forEach(v=>{
          if(v.ischecked){
            v.ruleTypeNumber = "notConsume"
          }else{
            v.ruleTypeNumber = ""
          }
        })
        this.loopList[1].ruleList.forEach(v=>{
          if(v.ischecked){
            v.ruleTypeNumber = "notContact"
          }else{
            v.ruleTypeNumber = ""
          }
        })
        this.loopList[2].ruleList.forEach(v=>{
          if(v.ischecked){
            v.ruleTypeNumber = "notConsumeEvery"
          }else{
            v.ruleTypeNumber = ""
          }
        })
        if (this.checked3) {
          this.unassignGuiderRuleList4 = [
            {
              ruleTypeNumber: "leave"
            }
          ];
        }else{
          this.unassignGuiderRuleList4 = [
            {
              ruleTypeNumber: ""
            }
          ];
        }
        this.unassignGuiderRuleList1 = this.loopList[0].ruleList;
        this.unassignGuiderRuleList2 = this.loopList[1].ruleList;
        this.unassignGuiderRuleList3 = this.loopList[2].ruleList;
        
        this.RuleSwitch= [
          {
            ruleList:this.unassignGuiderRuleList1,
          },
          {
            ruleList:this.unassignGuiderRuleList2,
          },
          {
            ruleList:this.unassignGuiderRuleList3,
          },
          {
            ruleList:this.unassignGuiderRuleList4,
          }
        ]
        
        let params = {
            unassignGuiderRuleList: this.RuleSwitch,
            unassignGuiderRuleSwitch: "yes"
        }
        console.log("params:",params);
        this.unassignRuleConfig(params);
      }
      if (type == "no" && pop == "pop2") {
        this.dialogVisible2 = false;
      }
    },
    //分配规则弹框关闭
    dialogVisibleClose1() {
      this.dialogVisible1 = false;
    },
    //取消分配规则弹框关闭
    dialogVisibleClose2() {
      this.dialogVisible2 = false;
    },
    // 获取商城分配规则
    async getgonghaiRule1() {
      const { result } = await this.$store.dispatch("getgonghaiRuleInfo");
      console.log("getgonghaiRule1--result", result);
      if (result) {
        this.switchValue1 =
          result.assignGuiderRuleSwitch == "yes" ? true : false;
        this.assignGuiderRule1 = result.assignGuiderRule;
        if (this.assignGuiderRule1) {
          if (
            this.assignGuiderRule1.allotGuiderType == "contact" &&
            this.assignGuiderRule1.ruleTypeNumber == "contact"
          ) {
            this.radio1 = "1";
          }
          if (
            this.assignGuiderRule1.allotGuiderType == "contact" &&
            this.assignGuiderRule1.ruleTypeNumber == "consumeContact"
          ) {
            this.radio1 = "2";
            this.input11 = this.assignGuiderRule1.contactDay;
            this.input12 = this.assignGuiderRule1.saleMoney;
          }
          if (
            this.assignGuiderRule1.allotGuiderType == "sale" &&
            this.assignGuiderRule1.ruleTypeNumber == "consumeSale"
          ) {
            this.radio1 = "3";
            this.input13 = this.assignGuiderRule1.contactDay;
            this.input14 = this.assignGuiderRule1.saleMoney;
          }
          if (
            this.assignGuiderRule1.allotGuiderType == "sale" &&
            this.assignGuiderRule1.ruleTypeNumber == "sale"
          ) {
            this.radio1 = "4";
            this.input15 = this.assignGuiderRule1.saleMoney;
          }
        }
      }
    },
    // 获取商城取消分配规则
    async getgonghaiRule2() {
      console.log("获取商城取消分配规则getgonghaiRule2");
      const { result } = await this.$store.dispatch("getgonghaiUnRuleInfo");
      if (result) {
        console.log("result:",result);
        this.switchValue2 =
          result.unassignGuiderRuleSwitch == "yes" ? true : false;
        this.unassignGuiderRuleList = result.unassignGuiderRuleList || [];
        if (this.unassignGuiderRuleList.length > 0) {
          console.log("this.unassignGuiderRuleList:",this.unassignGuiderRuleList);
          this.unassignGuiderRuleList.forEach((item,index) => {
              item.ruleList.forEach((item2,index2)=>{
                if(item2.ruleTypeNumber){
                  item2.ischecked=true;
                  if (item2.ruleTypeNumber == "leave") {
                  this.checked3 = true;
                  }else{
                  this.checked3 = false;
                  }
                }else{
                  item2.ischecked=false;
                }
              })
              this.loopList[index].ruleList = item.ruleList;
              
              let temptype="";
              if(item.ruleList[0].memberType==="全部会员")
              {
                temptype="";
              }else 
              if(item.ruleList[0].memberType==="普通会员")
              {
                temptype="normal";
              }else 
              if(item.ruleList[0].memberType==="plus会员")
              {
                temptype="plus";
              }            
              this.loopList[index].memberSelected = temptype;
            
          });
          console.log("this.loopList:",this.loopList);
        }
      }
    },
    // 公海会员分配导购配置
    async assignRuleConfig(params) {
      console.log("switchValue222", this.switchValue1);
      const { result } = await this.$store.dispatch("assignRuleConfig", params);
      this.$message({
        type: "warning",
        message: "修改成功"
      });
      this.switchValue1 = true;
      this.getgonghaiRule1();
      this.dialogVisible1 = false;
    },
    // 取消公海会员分配导购配置
    async unassignRuleConfig(params) {
      const { result } = await this.$store.dispatch(
        "unassignRuleConfig",
        params
      );
      this.$message({
        type: "warning",
        message: "修改成功"
      });
      this.getgonghaiRule2();
      this.dialogVisible2 = false;
    },
    // 公海会员-公海会员统计
    async getgonghaiSeasMeber() {
      const { result } = await this.$store.dispatch("getgonghaiSeasMeber", {
        queryStartTime: this.valueTime1[0],
        queryEndTime: this.valueTime1[1]
      });
      this.assignNums = result.assignNum;
      this.unassignNums = result.unassignNum;
    },
    // 公海会员-公海会员统计
    async getgonghaiSeasMeberNum() {
      const { result } = await this.$store.dispatch("getgonghaiSeasMeberNum");
      this.totalNum = result;
    },
    // 图表
    async gonghaiEcharts() {
      const { result } = await this.$store.dispatch("gonghaiEcharts", {
        queryStartTime: this.valueTime1[0],
        queryEndTime: this.valueTime1[1]
      });
      if (result) {
        this.optionLineData = result;
        let time = [];
        let data1 = [];
        let data2 = [];
        result.forEach(v => {
          time.push(v.timeQuantum);
          data1.push(v.assignNum);
          data2.push(v.unassignNum);
        });
        if (this.activeIndex == "1") {
          //series
          this.optionLine.series[0].data = data1;
          this.optionLine.series[0].itemStyle.normal.lineStyle.color =
            "#B839F2";
          this.optionLine.series[0].areaStyle.color = "#B839F2";
        }
        if (this.activeIndex == "2") {
          this.optionLine.series[0].data = data2;
          this.optionLine.series[0].itemStyle.normal.lineStyle.color =
            "#f58d34";
          this.optionLine.series[0].areaStyle.color = "#f58d34";
        }
        this.optionLine.xAxis.data = time;
        this.$nextTick(() => {
          var myChart = echarts.init(document.getElementById("mainline"));
          myChart.setOption(this.optionLine);
        });
      }
    },
    async gonghaiData1() {
      const { result } = await this.$store.dispatch("getgonghaiAssignList", {
        queryStartTime: this.selTime1[0],
        queryEndTime: this.selTime1[1],
        centerKeyword: this.input1,
        guiderKeyword: this.input2,
        pageNo: this.currentPage1,
        pageSize: this.pageSize1
      });
      this.total1 = result.total;
      this.pageSize1 = result.size;
      this.dataList1 = result.records;
    },
    async gonghaiData2() {
      const { result } = await this.$store.dispatch("getgonghaiUnAssignList", {
        queryStartTime: this.selTime2[0],
        queryEndTime: this.selTime2[1],
        centerKeyword: this.input3,
        guiderKeyword: this.input4,
        pageNo: this.currentPage2,
        pageSize: this.pageSize2
      });
      this.total2 = result.total;
      this.pageSize2 = result.size;
      this.dataList2 = result.records;
    },
    //查询职员业绩统计
    async queryEmployeeStatisticsList() {
      this.query.employeeStatistics.queryStartTime = this.query.employeeStatistics.employeeSelTime[0];
      this.query.employeeStatistics.queryEndTime = this.query.employeeStatistics.employeeSelTime[1];
      if (this.query.employeeStatistics.orgCodes && this.query.employeeStatistics.orgCodes.length > 0) {
        this.query.employeeStatistics.orgCode = this.query.employeeStatistics.orgCodes[this.query.employeeStatistics.orgCodes.length - 1];
      } else {
        this.query.employeeStatistics.orgCode = "";
      }
      const { result } = await this.$store.dispatch("getEmployeeStatisticsList", this.query.employeeStatistics);
      console.log("查询职员业绩统计result ======>", result);
      this.dataLists.employeeStatisticsList = result.records;
      this.dataLists.employeeStatisticsTotal = result.total;
    },
    //查询机构业绩统计
    async queryOrgStatisticsList() {
      this.query.orgCodeStatistics.queryStartTime = this.query.orgCodeStatistics.orgCodeSelTime[0];
      this.query.orgCodeStatistics.queryEndTime = this.query.orgCodeStatistics.orgCodeSelTime[1];
      //获取最后选择的机构
      this.query.orgCodeStatistics.orgCode = this.query.orgCodeStatistics.orgCodes[this.query.orgCodeStatistics.orgCodes.length - 1];
      const { result } = await this.$store.dispatch("getOrgStatisticsList", this.query.orgCodeStatistics);
      console.log("查询机构业绩统计result ======>", result);
      this.dataLists.orgCodeStatisticsList = result.records;
      this.dataLists.orgCodeStatisticsTotal = result.total;
    },
    // 查询按钮
    searchBtn(val) {
      if (val == "1") {
        this.gonghaiData1();
      }
      if (val == "2") {
        this.gonghaiData2();
      }
      if (val == "3") {
        this.queryEmployeeStatisticsList();
      }
      if (val == "4") {
        console.log("orgCode ======>", this.query.orgCodeStatistics.orgCode);
        if (!this.query.orgCodeStatistics.orgCodes || this.query.orgCodeStatistics.orgCodes.length < 1) {
          this.$message({
            type: "error",
            message: "请选择所属机构!"
          });
          return;
        }
        this.queryOrgStatisticsList();
      }
    },
    paging1(page) {
      this.currentPage1 = page;
      this.gonghaiData1();
    },
    handleSizeChange1(size) {
      this.currentPage1 = 1;
      this.pageSize1 = size;
      this.gonghaiData1();
    },
    paging2(page) {
      this.currentPage2 = page;
      this.gonghaiData2();
    },
    handleSizeChange2(size) {
      this.currentPage2 = 1;
      this.pageSize2 = size;
      this.gonghaiData2();
    },
    //职员业绩统计修改页数
    employeeChangePage(page) {
      this.query.employeeStatistics.pageNo = page;
      this.queryEmployeeStatisticsList();
    },
    //职员业绩统计修改每页条数
    employeeChangePageSize(size) {
      this.query.employeeStatistics.pageSize = size;
      this.queryEmployeeStatisticsList();
    },
    //机构业绩统计修改页数
    orgChangePage(page) {
      this.query.orgCodeStatistics.pageNo = page;
      this.queryOrgStatisticsList();
    },
    //机构业绩统计修改每页条数
    orgChangePageSize(size) {
      this.query.orgCodeStatistics.pageSize = size;
      this.queryOrgStatisticsList();
    },
    change2(e) {
      this.selTime2 = e;
    },
    change1(e) {
      this.selTime1 = e;
    },
    //职员业绩统计查询时间修改
    employeeChange(e) {
      this.query.employeeStatistics.employeeSelTime = e;
    },
    //机构业绩统计查询时间修改
    orgCodeChange(e) {
      this.query.employeeStatistics.orgCodeSelTime = e;
      this.query.employeeStatistics.orgCodeSelTime = e[0];
      this.query.employeeStatistics.orgCodeSelTime = e[1];
    },
    changeTime(e) {
      console.log("change---e", e);
      this.valueTime1 = e;
      this.gonghaiEcharts();
      this.getgonghaiSeasMeber();
    },
    changeischeck(e){
      this.loopList.splice();
      console.log("e.ischecked:",e.ischecked);
    },
    memberSelect(e){
      e.memberClass.forEach(v => {
        if(v.value === e.memberSelected)
        {  
          e.ruleList[0].memberType = v.name;
        }
      });
      e.ruleList.splice(1, 1);
    },
    addChildren(item) {
      let temp="";
      if(item.ruleList[0].memberType==="普通会员")
      {
        temp="plus会员";
      }
      else if(item.ruleList[0].memberType==="plus会员")
      {
        temp="普通会员";
      }
      let params = {
        memberType:temp,
        ischecked:true,
        bindingDay:"",
        ruleDay:"",
        saleMoney:"",
        // ruleTypeNumber:"true",
      };
      item.ruleList.push(params);
    },
    removeChild(item, index) {
      item.ruleList.splice(1, 1);
    },
  }
};
</script>
<style lang="scss" scoped>
div,
p,
h6 {
  margin: 0;
  padding: 0;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.page {
  flex-direction: column;
}

.page_top {
  // height: 168px;
  background: #ffffff;
  padding: 30px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-right: 20px;
  margin-bottom: 10px;
  display: flex;
  .steps_content_day {
    flex: 1;
  }
  .wechat_img {
    width: 76px;
    height: 76px;
    float: right;
  }
  .list {
    width: 100%;
    height: 30px;
    line-height: 20px;
    .txt {
      color: #222222;
      font-size: 14px;
      margin: 0 20px;
    }
  }
  .switch_txt {
    font-size: 12px;
    color: #666666;
    margin-left: 128px;
    margin-bottom: 20px;
    span {
      display: block;
      line-height: 20px;
      margin-left: 62px;
    }
  }
  .switch_txt_wechat {
    font-size: 12px;
    color: #666666;
    margin-left: 188px;
    margin-bottom: 20px;
  }
}
.change_col_btn {
  color: #0081e5;
  line-height: 20px;
  font-size: 14px;
  margin: 0px 0 5px 130px;
  width: 60px;
  display: block;
  box-sizing: border-box;
}
.change_col_btn:hover {
  cursor: pointer;
  opacity: 0.8;
}
.trend {
  margin-top: 10px;
  padding: 10px 20px;
  background: #ffffff;
}
.tabForm {
  padding: 20px;
  background: #ffffff;
  margin: 10px 0;
  margin-right: 20px;
  .tabForm_top {
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    .tabForm_top_col {
      height: 16px;
      width: 3px;
      background: red;
      display: inline-block;
      margin-right: 5px;
    }
    .inpts {
      margin-left: 10px;
      width: 200px;
    }
  }
  .statistic {
    width: 100%;
    height: 120px;
    .statistic_list {
      width: 180px;
      margin-right: 32px;
      .clo1 {
        width: 180px;
        height: 4px;
        background: #b839f2;
        border-radius: 6px 6px 0px 0px;
      }
      .clo2 {
        width: 180px;
        height: 4px;
        background: #f58d34;
        border-radius: 6px 6px 0px 0px;
      }
      .clo3 {
        width: 180px;
        height: 4px;
        background: #16ceb9;
        border-radius: 6px 6px 0px 0px;
      }
      .user_num {
        height: 20px;
        font-size: 14px;
        color: #222222;
        line-height: 20px;
        margin: 10px;
        text-align: center;
      }
      .detail {
        height: 28px;
        font-size: 20px;
        font-weight: 600;
        color: #222222;
        text-align: center;
        .change_col {
          color: #0081e5;
          font-size: 14px;
        }
        .change_col:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }
    }
    .statistic_list:hover {
      cursor: pointer;
    }
  }
  .seleteTime .fr {
    margin-left: 5px;
  }
}
.tables {
  //max-height: 800px;
}
.tabForm_tables {
  overflow-y: hidden;
}

.btn-wrapper {
  border-top: 1px solid #dddddd;
}
.next_btn {
  margin-top: 150px;
  margin-left: 50%;
  transform: translate(-50%);
}
.steps_content {
  border-top: 1px solid #dddddd;
  padding: 15px 0;
  .steps_content_txt {
    font-size: 14px;
    color: #999999;
    line-height: 40px;
    padding-bottom: 10px;
    span {
      color: #0081e5;
    }
    .col_sucess {
      color: #2fc348;
    }
  }
  .steps_content_day {
    line-height: 60px;
    >>> .steps_content_day_lt {
      font-size: 14px;
      font-weight: 500;
      color: #222222;
      margin-bottom: 20px;
      float:left;
    }
    .radio_span {
      display: inline-block;
      margin: 0 8px;
      color: #222222;
    }
    .content_day {
      width: 118px;
      height: 42px;
      border-radius: 8px;
      margin: 0 20px;
    }
    .steps_content_day_rt {
      font-size: 14px;
      font-weight: 400;
      color: #222222;
    }
    .content_sel {
      margin: 0 20px;
      width: 300px;
    }
    .switch_txt {
      padding: 0;
      line-height: 20px;
      margin: 10px;
      margin-left: 120px;
    }
  }
}
.content_sel {
  margin: 0 20px;
  width: 300px;
  // padding: 0 10px;
}
.btn_box {
  margin: 0 auto;
  margin-top: 150px;
  text-align: center;
}
input {
  width: 200px;
}
.clear{ 
  overflow:hidden; _height:1px; _overflow:visible;
}
.clean{ 
  font-size:0px; line-height:0px; clear:both;
}
.loopList_div .title{
  color: #e50065;
  margin-bottom: 20px;
}
.add-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  .hmicon {
    font-size: 14px;
  }
}

.minus-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}
</style>
